var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-content"},[_vm._m(0),_c('login-info',{on:{"loginCb":_vm.loginCb}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-content-bg"},[_c('img',{attrs:{"src":require("../assets/other/wechat.jpeg")}})])
}]

export { render, staticRenderFns }